import { render, staticRenderFns } from "./WxPay.vue?vue&type=template&id=44baaf35&"
import script from "./WxPay.vue?vue&type=script&lang=js&"
export * from "./WxPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports